import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import './carrucel.css';
import slider1 from '../../assets/images/carrucel/slider1.png'
import slider2 from '../../assets/images/carrucel/slider2.png'
import slider3 from '../../assets/images/carrucel/slider3.png'
import slider4 from '../../assets/images/carrucel/slider4.png'
import slider5 from '../../assets/images/carrucel/slider5.png'


const Carrucel = () => {
    
    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1,
          slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2,
          slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          slidesToSlide: 1 // optional, default to 1.
        }
      };


    return (
        <Carousel
            swipeable={false}
            draggable={false}
            showDots={true}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={3000}
            keyBoardControl={true}
            transitionDuration={500}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            itemClass="carousel-item-padding-40-px"
            >
            <img src={slider1} alt="Imagen 1" className="item-image"/>
            <img src={slider2} alt="Imagen 2" className="item-image"/>
            <img src={slider3} alt="Imagen 3" className="item-image"/>
            <img src={slider4} alt="Imagen 4" className="item-image"/>
            <img src={slider5} alt="Imagen 5" className="item-image"/>
        </Carousel>
    );
}

export default Carrucel;
